import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { format_fancy, getTimeInIST } from '../Utils';
import { Grid, Divider, Fade, LinearProgress } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import { UserService } from '../Services/UserService';

const useStyles = makeStyles(theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    sectionHeading: {
        fontSize: theme.typography.pxToRem(16),
        fontWeight: theme.typography.fontWeightMedium,
    },
    heading: {
        fontSize: theme.typography.pxToRem(14),
        fontWeight: theme.typography.fontWeightMedium,
    },
    subheading: {
        fontSize: theme.typography.pxToRem(14),
        fontWeight: theme.typography.fontWeightRegular,
        textAlign: "left"
    },
    subheadingLink: {
        fontSize: theme.typography.pxToRem(14),
        fontWeight: theme.typography.fontWeightRegular,
        textAlign: "left",
        color: "blue",
        textDecoration: "underline",
        cursor: "pointer"
    }
}));

const DialogTitle = (props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function UploadedDocumentsView(props) {
  const [open, setOpen] = React.useState(props.id ? true : false);
  const [loading, setLoading] = React.useState(false);

  const [title, setTitle] = React.useState(undefined);
  const [details, setDetails] = React.useState([]); 

  const classes = useStyles();

    function openLink(link){
        window.open(link, "_blank")
    }

    React.useEffect(() => {
        setOpen(props.open)
    }, [props.id && props.open]);

    React.useEffect(() => {
    if(open && props.id){
        setLoading(true);
        let details = [];
        setTitle(`Uploaded Documents`);
        UserService.getDocuments(props.id)
        .then((data) => {
            if(data.documents && data.documents.length > 0){
                data.documents.forEach((doc, index) => {
                    details.push(
                        <Grid item container xs={12} lg={12} key={index} spacing={2}  alignItems="center" style={{paddingTop: 8, paddginBottom: 8}}>
                            <Grid item xs={6} lg={3}>
                                <Typography className={classes.subheading} style={{textAlign: 'left'}}>{index + 1}</Typography>
                            </Grid>
                            <Grid item xs={6} lg={3}>
                                <Typography className={classes.subheading} style={{textAlign: 'left'}}>{doc.file_type}</Typography>
                            </Grid>
                            <Grid item xs={6} lg={3}>
                                <Typography className={classes.subheadingLink} style={{textAlign: 'left'}} onClick={(e) => openLink(doc.document_url)}>{doc.file_name}</Typography>
                            </Grid>
                            <Grid item xs={6} lg={3}>
                                <Typography className={classes.subheading} style={{textAlign: 'left'}}>{getTimeInIST(doc.created_date).format(format_fancy)}</Typography>
                            </Grid>
                            <Grid item xs={12} lg={12}>
                                <Divider variant="fullWidth"/>
                            </Grid>
                        </Grid>);
                })
            } else {
                details.push(
                    <Grid item container xs={12} lg={12} key={"no-document-row"} spacing={2}  alignItems="center">
                        <Grid item xs={12} lg={12}>
                            <Typography className={classes.subheading} style={{textAlign: 'center', paddingTop: 24, paddginBottom: 24}}>No Documents uploaded.</Typography>
                        </Grid>
                    </Grid>);
            }
            setLoading(false);
            setDetails(details);
        })
        .catch((error) => {
            console.log(error);
            setLoading(false);
        });
    }
}, [open]);

 
  const handleClose = () => {
    props.close();
    setOpen(false);
  };

  return (
      <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open} fullWidth maxWidth="md">
        <DialogTitle id="customized-dialog-title" onClose={handleClose} classes={classes}>
          {title}
        </DialogTitle>
        <DialogContent dividers>
            <Grid container justify="flex-start" alignItems="center" direction="row">
                <Grid item xs={12} lg={12}>
                    <Fade
                        in={loading}
                        style={{
                            transitionDelay: loading ? '10ms' : '0ms'
                        }}
                        unmountOnExit
                        >
                        <LinearProgress style={{height: 5, width: "100%"}} color="secondary"/>
                    </Fade>
                </Grid>
                <Grid item container xs={12} lg={12} key={"header"} spacing={2}  alignItems="center">
                    <Grid item xs={6} lg={3}>
                        <Typography className={classes.heading} style={{textAlign: 'left'}}>Sl.No.</Typography>
                    </Grid>
                    <Grid item xs={6} lg={3}>
                        <Typography className={classes.heading} style={{textAlign: 'left'}}>File Type</Typography>
                    </Grid>
                    <Grid item xs={6} lg={3}>
                        <Typography className={classes.heading} style={{textAlign: 'left'}}>Link</Typography>
                    </Grid>
                    <Grid item xs={6} lg={3}>
                        <Typography className={classes.heading} style={{textAlign: 'left'}}>Uploaded on</Typography>
                    </Grid>
                </Grid>
                {details}
            </Grid>
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={handleClose} color="primary">
                    Close
                </Button>
            </DialogActions>
      </Dialog>
  );
}